import React, { useEffect, useState } from 'react';
import getCreditAppeal from '../../api/deals/getCreditAppeal';
import selectCreditAppeal from '../../api/creditPlatform/selectCreditAppeal';
import Button from '../Button/Button';
import { BankOffersSkeleton } from './CreditSkeletons';
import formatNumber from '../../utils/formatNumber';
import alert from '../../helpers/alert';
import { BANK_CREDIT_ACCEPTED, BANK_CREDIT_REJECTED, BANK_CREDIT_STATUSES } from '../../constants/bankCreditStatuses';
import { DEAL_STATUS_TTL_EXPIRED } from '../../constants/dealStatuses';
import styles from '../../pages/Deal/deal.module.css';

/**
 * ÐÑÐ²ÐµÑÑ Ð±Ð°Ð½ÐºÐ¾Ð² Ð¿Ð¾ ÑÐ´ÐµÐ»ÐºÐµ â Ð´Ð»Ñ ÑÐ°Ð·Ð´ÐµÐ»Ð° "ÐÐ¸Ð´Ñ" (Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð²ÑÐ±Ð¸ÑÐ°ÐµÑ Ð¾ÑÑÐµÑ Ð·Ð°
 * ÐºÐ»Ð¸ÐµÐ½ÑÐ°). Ð£Ð¿ÑÐ¾ÑÑÐ½Ð½Ð°Ñ Ð²ÐµÑÑÐ¸Ñ ÐºÐ°ÑÑÐ¾ÑÐµÐº Ð¸Ð· DealCredits.jsx: ÑÐ°Ð¼ Ð²ÑÑ Ð·Ð°Ð²ÑÐ·Ð°Ð½Ð¾ Ð½Ð°
 * ÑÑÐµÐ¿-Ð¼Ð°ÑÐ¸Ð½Ñ ÑÐ´ÐµÐ»ÐºÐ¸ (generateCheck, DEAL_STEPS, StepControlButtons), ÐºÐ¾ÑÐ¾ÑÐ°Ñ
 * ÑÑÑ Ð½Ðµ Ð½ÑÐ¶Ð½Ð° â Ð¿ÑÐ¾ÑÑÐ¾ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¾ÑÑÐµÑÐ¾Ð² Ð¸ Ð²ÑÐ±Ð¾Ñ. ÐÐ°Ð¼ÐµÐ½Ð° Ð¼Ð°ÑÐ¸Ð½Ñ â ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹ Ð² Ð±Ð»Ð¾ÐºÐµ
 * Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð²ÑÑÐµ (LeadDealInfo), Ð¾Ð´Ð½Ð° Ð½Ð° ÑÐ´ÐµÐ»ÐºÑ.
 */
const LeadBankOffers = ({ chunkId, dealStatusId, onOfferSelected }) => {
  const [appeals, setAppeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const [choosing, setChoosing] = useState(null);

  const isExpired = dealStatusId === DEAL_STATUS_TTL_EXPIRED;

  const init = () => {
    if (!chunkId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setLoadError(false);
    getCreditAppeal({ chunkId })
      .then((res) => setAppeals(res.data?.appeals || []))
      .catch(() => setLoadError(true))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    init();
  }, [chunkId]);

  const chooseBank = async (appeal) => {
    setChoosing(appeal.id);
    try {
      await selectCreditAppeal({ appealId: appeal.id, offerType: appeal.offerType });
      init();
      onOfferSelected?.();
    } catch (e) {
      alert.error(e?.response?.data?.errorMessage || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð²ÑÐ±Ð¾ÑÐµ Ð±Ð°Ð½ÐºÐ°');
    } finally {
      setChoosing(null);
    }
  };

  if (loading) return <BankOffersSkeleton />;

  if (!chunkId) {
    return <p>Ð¡Ð´ÐµÐ»ÐºÐ° ÐµÑÑ Ð½Ðµ ÑÐ¾Ð·Ð´Ð°Ð½Ð° â Ð·Ð°ÑÐ²ÐºÐ¸ Ð² Ð±Ð°Ð½ÐºÐ¸ ÐµÑÑ Ð½Ðµ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÐ»Ð¸ÑÑ.</p>;
  }

  if (loadError) {
    return (
      <div>
        <p style={{ color: '#EE7171', marginBottom: 10 }}>ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð·Ð°ÑÐ²ÐºÐ¸ Ð² Ð±Ð°Ð½ÐºÐ¸.</p>
        <Button text="ÐÐ¾Ð²ÑÐ¾ÑÐ¸ÑÑ" onClick={init} />
      </div>
    );
  }

  return (
    <div>
      {isExpired && (
        <div style={{ background: '#FDEDED', border: '1px solid #EE7171', borderRadius: 8, padding: '10px 16px', marginBottom: 16 }}>
          ÐÐ°Ð½ÐºÐ¸ Ð½Ðµ Ð¾ÑÐ²ÐµÑÐ¸Ð»Ð¸ Ð² ÑÑÐ¾Ðº. Ð§ÑÐ¾Ð±Ñ Ð²ÑÐ±ÑÐ°ÑÑ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ, Ð¿Ð¾Ð´Ð±ÐµÑÐ¸ÑÐµ Ð´ÑÑÐ³Ð¾Ð¹ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð²ÑÑÐµ.
        </div>
      )}

      {appeals.length === 0 ? (
        <p>ÐÐ°ÑÐ²Ð¾Ðº Ð² Ð±Ð°Ð½ÐºÐ¸ Ð¿Ð¾ ÑÑÐ¾Ð¹ ÑÐ´ÐµÐ»ÐºÐµ Ð¿Ð¾ÐºÐ° Ð½ÐµÑ.</p>
      ) : (
        appeals.map((item) => (
          <div className={styles.bank} key={item.id} style={isExpired ? { opacity: 0.6 } : undefined}>
            <div className={styles.bank__row}>
              <div className={styles.bank__img}>
                <img src={item?.bank?.logo} alt={item?.bank?.name} />
              </div>
              <p className={styles.bank_name}>{item?.bank?.name}</p>
              <p
                className={`${styles.status} ${
                  item?.statusId === BANK_CREDIT_ACCEPTED ? styles.status__accepted : ''
                } ${item?.statusId === BANK_CREDIT_REJECTED ? styles.status__rejected : ''}`}
              >
                {BANK_CREDIT_STATUSES[item?.statusId]}
              </p>
            </div>
            {item?.errorMessage && (
              <div style={{ padding: '0 20px', marginBottom: 12 }}>
                <p className={styles.sub} style={{ color: '#EE7171', wordBreak: 'break-all' }}>
                  {item.errorMessage}
                </p>
              </div>
            )}
            <div className={styles.bank__info} style={{ padding: '0 20px' }}>
              {item?.loan_amount ? (
                <div className={styles.bank__info_row}>
                  <p className={styles.bank__info_title}>Ð¡ÑÐ¼Ð¼Ð° Ð·Ð°Ð¹Ð¼Ð°</p>
                  <p className={styles.bank__info_sub}>{formatNumber(item.loan_amount)}</p>
                </div>
              ) : null}
              <div className={styles.bank__info_row}>
                <p className={styles.bank__info_title}>ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ</p>
                <p className={styles.bank__info_sub}>{formatNumber(item?.initialFee)}</p>
              </div>
              <div className={styles.bank__info_row}>
                <p className={styles.bank__info_title}>Ð¡ÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ</p>
                <p className={styles.bank__info_sub}>{item?.period} Ð¼.</p>
              </div>
              <div className={styles.bank__info_row}>
                <p className={styles.bank__info_title}>ÐÑÐ¾ÑÐµÐ½ÑÐ½Ð°Ñ ÑÑÐ°Ð²ÐºÐ°</p>
                <p className={styles.bank__info_sub}>{item?.percent}%</p>
              </div>
              <div className={styles.bank__info_row}>
                <p className={styles.bank__info_title}>ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÑÐ¶</p>
                <p className={styles.bank__info_sub}>{formatNumber(item?.monthlyPayment)}</p>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-start', padding: '0 20px 20px' }}>
              <Button
                text="ÐÑÐ±ÑÐ°ÑÑ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ"
                fill
                disabled={choosing === item.id || isExpired}
                onClick={() => chooseBank(item)}
              />
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default LeadBankOffers;
